import { CopyIcon, PasteIcon } from "../../../Components";
import "./CopyPaste.scss";
import React from "react";

export default function CopyPaste(props) {
  const copyRow = props.copyRow;
  const pasteRow = props.pasteRow;
  const mask = props.mask;

  return (
    <div className="copyPaste">
      <div title="copy">
        <CopyIcon size="24" onClick={() => copyRow()} />
      </div>
      {mask && (
        <div title="paste">
          <PasteIcon size="24" onClick={() => pasteRow()} />
        </div>
      )}
      {!mask && (
        <div title="paste disabled">
          <PasteIcon title="paste" size="24" disabled={true} />
        </div>
      )}
    </div>
  );
}
